const state = {
  headerName: "",
};

const mutations = {
  SETHEADER: function (state, txt) {
    state.headerName = txt;
  },
};

const actions = {
  setHeader: ({ commit }, txt) => {
    commit("SETHEADER", txt);
  },
};

export default {
  state,
  mutations,
  actions,
};
